import { Injectable } from '@angular/core';

@Injectable({
   providedIn: 'root'
})
export class InfoService {
   tooltips: string[] = [];

   constructor() { }
   reset() {
      this.tooltips = [];
   }
}
